import React, {Component} from 'react'
import {Jumbotron} from 'react-bootstrap'

import './index.css'

class Header extends Component {
  render() {
    return (
      <header>
        <Jumbotron className='header'>
          <h1>{this.props.name}</h1>
          <p>{this.props.title}</p>
        </Jumbotron>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/App/Header/index.js